import { render, staticRenderFns } from "./CallRow.vue?vue&type=template&id=3407a66d&scoped=true&"
import script from "./CallRow.vue?vue&type=script&lang=ts&"
export * from "./CallRow.vue?vue&type=script&lang=ts&"
function injectStyles (context) {
  
  var style0 = require("./CallRow.vue?vue&type=style&index=0&id=3407a66d&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3407a66d",
  null
  ,true
)

export default component.exports